export default __webpack_public_path__ + "static/media/fireEngine_icon.6c76c3f2.svg";